/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Relationship/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Relationship({
  children,
  viewPath = "/DesignSystem/LedgerPaymentAccount/PersonPaymentAccount/Payor/Person/Content/Content/Relationship"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let personFromPersonRelationshipsValueData = fromData.useDataFormat({ viewPath,
context: 'person',
path: 'from_person_relationships',
format: fromFormat.isNotEmptyList,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(personFromPersonRelationshipsValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}